export const FLAG_GETTING_ACTIVITIES = 'FLAG_GETTING_ACTIVITIES';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
export const FLAG_ACTIVITY_ACTIVITY = 'FLAG_ACTIVITY_ACTIVITY';
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const CLEAR_ACTIVITY = 'CLEAR_ACTIVITY';
